import React, { useState } from 'react';
import './PictureGallery.css';

// All images - local images for all users (no premium/free distinction)
const imageFiles = [
  'forest-3622519_1920.jpg',
  'grass-8020116_1920.jpg',
  'mountain-3807667_1920.jpg',
  'mourad-saadi-GyDktTa0Nmw-unsplash.jpg',
  'nathan-dumlao-ciO5L8pin8A-unsplash.jpg',
  'nature-8727795_1920.jpg',
  'pawel-czerwinski-6lQDFGOB1iw-unsplash.jpg',
  'tree-8175062_1920.jpg',
  'wallpaper-4301176_1920.jpg',
  'dave-hoefler-PEkfSAxeplg-unsplash.jpg',
  'kazuend-2KXEb_8G5vo-unsplash.jpg',
  'mona-eendra-vC8wj_Kphak-unsplash.jpg',
  'pawel-nolbert-wE_Dk2Kd3GQ-unsplash.jpg',
  'staffan-kjellvestad-y1qOT82fd8k-unsplash.jpg',
  'teemu-paananen-OOE4xAnBhKo-unsplash.jpg'
];

// Generate image URLs
const images = imageFiles.map(filename => `/images/${filename}`);

const PictureGallery = ({ selectedImage, setSelectedImage }) => {
  const handleImageSelect = (imageUrl) => {
    setSelectedImage(imageUrl);
  };

  const handleImageError = (e, imageUrl) => {
    console.warn(`Failed to load image: ${imageUrl}`);
  };

  const renderImageGrid = (images) => {
    return (
      <div className="image-grid">
        {images.map((imageUrl, index) => (
          <div
            key={index}
            className={`image-item ${selectedImage === imageUrl ? 'selected' : ''}`}
            onClick={() => handleImageSelect(imageUrl)}
          >
            <img
              src={imageUrl}
              alt={`Background ${index + 1}`}
              loading="lazy"
              onError={(e) => handleImageError(e, imageUrl)}
              style={{
                objectFit: 'cover',
                aspectRatio: '9/16'
              }}
            />
          </div>
        ))}
      </div>
    );
  };

  return (
    <div className="picture-gallery">
      <div className="gallery-header">
        <h3>背景图片</h3>
      </div>

      <div className="gallery-content">
        {renderImageGrid(images)}
      </div>
    </div>
  );
};

export default PictureGallery;